import { Outlet } from "react-router-dom";

const Shop = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Shop;
